import '.cg{font-size:1.125rem;}.ssr-plugin'
import '.eh{line-height:1.75rem;}.ssr-plugin'
import '.eb{text-decoration:none;}.ssr-plugin'
import '.ej{color:var(--primary-red);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="cg eh"
    >
      {translations.privacySubtitle}{' '}
      <a className="eb ej"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="eb ej"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
